export const LeftLongArrow = () => {
  return (
    <svg
      width="124"
      height="12"
      viewBox="0 0 124 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-7.62939e-06 5.77345L9.99999 11.5469L9.99999 -5.57102e-05L-7.62939e-06 5.77345ZM120 5.77344L120 4.77344L8.99999 4.77345L8.99999 5.77345L8.99999 6.77345L120 6.77344L120 5.77344Z"
        fill="white"
      />
      <rect x="118" y="2.77344" width="6" height="6" rx="3" fill="white" />
    </svg>
  );
};
